/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// clchart 只关心根据标准输入数据画图
import ClDrawZLine from './chart/cl.draw.zline'
import ClDrawKBar from './chart/cl.draw.kbar'
import ClDrawVBar from './chart/cl.draw.vbar'
import ClDrawVLine from './chart/cl.draw.vline'
import ClDrawHbar from './chart/cl.draw.hbar'
import ClDrawMark from './chart/cl.draw.mark'

//////////////////////////////////////////
// 这里是默认的公用配置
// 第一部分为数据定义
//////////////////////////////////////////

// 字符串和全角字符映射表
export const ASCIIMAPS = {
    '1': '①',
    '2': '②',
    '3': '③',
    '4': '④',
    '5': '⑤',
    '6': '⑥',
    '7': '⑦',
    '8': '⑧',
    '9': '⑨',
    '10': '⑩',
    '$': '＄',
    '¥': '￥',
    '%': '％',
    '%10': '‰',
    '<=': '≤',
    '>=': '≥',
    '==': '≡',
    '~=': '≈',
    '!=': '≠',
    'kup': '△',
    'kdn': '▽',
    'bid': '▲',
    'ask': '▼',
    'kcir': '○',
    'fcir': '●',
    'scir': '◎',
    'ksqu': '□',
    'fsqu': '■',
    'kbox': '◇',
    'fbox': '◆',
    'kwjx': '☆',
    'fwjx': '★',
    'sum': '∑',
    'jif': '∫',
    'beta': 'β',
    'alpha': 'α',
    'gamma': 'γ',

}

//////////////////////////////////////////
// 特别注意 以下的数据字段定义不能修改名称 
// 
//////////////////////////////////////////

// 两种单线的定义
export const FIELD_LINE = {
    time: 0,
    value: 1
}
export const FIELD_ILINE = {
    index: 0,
    value: 1
}

//////////////////////////////////////////
// 这里是默认的公用配置
// 第二部分为图表定义
//////////////////////////////////////////


export const CHART_LAYOUT = {
    margin: { // 画图区和边界的距离
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
    },
    offset: { // 图形的偏移位置（不包括标题等），margin为整个图形区，offset仅仅是图形
        left: 1,
        top: 1,
        right: 1,
        bottom: 1,
    },
    title: { // 标题栏的配置
        pixel: 12, // 字体大小
        height: 18, // 最大高度
        spaceX: 10, // X方向留空
        spaceY: 2, // Y方向留空
        font: 'sans-serif'
    },
    axisX: { // 纵坐标显示的配置
        pixel: 12,
        height: 18,
        maxchs: 7, // 最大宽度
        spaceX: 2,
        font: 'sans-serif'
    },
    scroll: { // 最低下针对曲线的全量游标配置
        pixel: 12,
        size: 15, // 游标块的大小
        spaceX: 10,
        font: 'sans-serif'
    },
    digit: { // 数字显示的字体和配置
        pixel: 13,
        height: 16,
        spaceX: 3,
        // font: 'Roboto Mono'
        font: 'Cousine'
    },
    symbol: { // 符号，比如箭头等的字体和配置
        pixel: 8,
        size: 18,
        spaceX: 3,
        spaceY: 1,
        font: 'sans-serif'
    }
}


///////////  数据看板开始 ////////////
// 这里仅仅是一个例子
export const CHART_BOARD = {
    style : 'normal', // 'fwindows', 表示浮动窗口
    // 标题 定义
    title: {
        display: 'none', // none text 
        align: 'left', // 默认 right
        spaceX: 2, // X方向留空  
        spaceY: 3, // Y方向留空  
        pixel: 13, // 字体大小
        font: 'sans-serif',
        clr: 'label',
        label: '看板', // label information to be displayed
        // 按钮定义 包含在标题栏目中 标题需要填充背景色
        // buttons: [{ 
        //     clickName: 'zoomin',
        //     drawMethod: 'decr', // 画+号
        // }],
    },
    // 头信息定义 通常用于需要特殊显示的数据
    header: {
        display: 'none', // none text
        align: 'left', // 默认 right
        spaceX: 2, // X方向最小的留空 默认平分区间
        spaceY: 3, // Y方向留空  
        pixel: 15, // 字体大小
        font: 'sans-serif',
        // cols 下的信息 以 label 信息优先 如果有值 就不再使用 field 和 getvar
        // clr 优先级大于 getclr
        rows: [
            // {
            //     cols: []
            // },
            // {
            //     cols: []
            // }
        ],
    },
    // 统一表格信息
    boards: {
        align: 'left', // 默认 right
        spaceX: 2, // X方向最小的留空 默认平分区间
        spaceY: 3, // Y方向留空  
        pixel: 15, // 字体大小
        font: 'sans-serif',

        upper: {
            display: 'none', // 顶部信息 text 显示label data根据cols取字段信息 line 显示分隔横线 rate 显示百分比图
            spaceX: 2, // X方向最小的留空 默认平分区间
            spaceY: 3, // Y方向留空  
            pixel: 15, // 字体大小
            rows: [
                // {
                //     cols: []
                // },
                // {
                //     cols: []
                // }
            ],
        },
        footnote: {
            display: 'none', // 底部信息 text 显示label data根据cols取字段信息 line 显示分隔横线 rate 显示百分比图
            spaceX: 2, // X方向最小的留空 默认平分区间
            spaceY: 3, // Y方向留空  
            pixel: 15, // 字体大小
            rows: [
                // {
                //     cols: []
                // },
                // {
                //     cols: []
                // }
            ],
        },
        middle: {
            display: 'none', // 中间信息 text 显示label data根据cols取字段信息 line 显示分隔横线 rate 显示百分比图
            spaceX: 2, // X方向最小的留空 默认平分区间
            spaceY: 3, // Y方向留空  
            pixel: 15, // 字体大小
            rows: [
                // {
                //     cols: []
                // },
                // {
                //     cols: []
                // }
            ],
        },
        // 注意 middle 和 cols 只能选1 middle 优先
        cols: [
            // {
            //     label: '买1', // 
            //     maxchs: 2, // 最小宽度 字符
            // },
            // {
            //     field: 'askp0',
            //     maxchs: 7, // 最小宽度 字符
            // },
            // {
            //     field: 'askv0',
            //     maxchs: 5, // 最小宽度 字符
            // },
        ],
    }
}
// label = 'xxxxx'
export function changeBoardTitle(config, label, display) {
    if (display === undefined) {
        display = 'text'
    } else {
        config.title.display = display
    }
    if (config.title.display === 'text') {
        config.title.label = label
    }
}
// labels = ['xxx', 'xxx', ... ] 数量按 rows 和 cols的数量
export function changeBoardHeader(config, labels, display) {
    if (display === undefined) {
        display = 'text'
    } else {
        config.header.display = display
    }
    if (config.header.display === 'text') {
        let nums = 0
        for (let ridx = 0; ridx < config.header.rows.length; ridx++) {
            const record = config.header.rows[ridx];
            for (let cidx = 0; cidx < record.cols.length; cidx++) {
                if (nums < labels.length) {
                    record.cols[cidx].label = labels[nums]
                    nums++
                }
            }
        }
    }
}

///////////  数据看板结束 ////////////

///////////  表格专用开始 ////////////
export const CHART_TABLE = {
    // 标题配置
    gridline: {
        horizontal: true, // 横线
        vertical: true, // 竖线
        // altermode  :  false,  // 是否交替颜色 显示记录
        // altercolor1 :  '#333', // 
        // altercolor2 :  '#555', // 
    },
    header: {
        align: 'right',
        spaceX: 10, // X方向最小的留空
        spaceY: 5, // Y方向留空        
        pixel: 15, // 字体大小
        font: 'sans-serif',
        display: 'text' // 'text' or 'none','none' does not display btn button text
    },
    // 配置信息
    record: {
        align: 'right',
        spaceX: 5, // X方向最小的留空
        spaceY: 3,
        pixel: 14, // 字体大小
        font: 'sans-serif'
    },
    movecolor: '#ccc', // 光标的颜色
    fieldlock: 0, // 按左键时，前面3个字段不动
    fieldmins: 3,
    curKeyIdx: 0,
    maxchs: 8, // 最大英文字符数
    autoexpand : false,
    scrollHor: {
        width: 20,
        display: false
    },
    scrollVer: {
        width: 20,
        display: true
    },
}
///////////  表格专用结束 ////////////

export const ZOOM_INFO_DEF = {
    index: 5, // 当前默认缩放索引 实际比例要从 linkInfo 中获取
    list: [0.1, 0.5, 1, 2, 3, 4, 6, 8, 10, 13, 16, 19, 23] // 缩放比例如何变化，
}
///////////  可缩放图开始 ////////////
export const BUTTON_RIGHT = { // 除权
    clickName: 'exright',
    drawMethod: 'text', // 显示文本
    clickInfo: [{
            label: '权',
            value: 'none'
        },
        {
            label: '前',
            value: 'forword'
        },
        // { label : '后', value : 'after' },
    ],
}
export const BUTTON_LOCKED = { // 锁定
    clickName: 'locked',
    drawMethod: 'text', 
    clickInfo: [{
            label: '锁',
            value: 'locked'
        },
        {
            label: '开',
            value: 'opened'
        },
    ],
}
export const BUTTON_ZOOMIN = { // 放大
    clickName: 'zoomin',
    drawMethod: 'decr', // 画+号
}
export const BUTTON_ZOOMOUT = { // 缩小 
    clickName: 'zoomout',
    drawMethod: 'incr', // 画-号
}
export const CHART_KBAR_FIRST = {
    zoomInfo: ZOOM_INFO_DEF,
    buttons: [
        BUTTON_ZOOMIN,
        BUTTON_ZOOMOUT,
        BUTTON_LOCKED,
        BUTTON_RIGHT,
    ],
    scroll: { // 是否显示下方的游标
        display: 'normal' // 'none' does not show normal
    },
    title: { // 标题
        display: 'text', // none does not show btn button text
        label: 'K线' // label information to be displayed
    },
    axisX: {
        display: 'none',
        lines: 0, // 纵向线有几根，不包括两边的框线
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'none',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 3, // 横向线有几根
        left: { //左边的坐标信息
            display: 'both', // none不显示 both上下都显示 noupper不显示最上坐标, nofoot不显示最下坐标
            middle: 'none', // 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price', // 输出数据的格式 rate price vol money float
        },
        right: { //右边的坐标信息
            display: 'both', // none不显示 both上下都显示 noupper不显示最上坐标, nofoot不显示最下坐标
            middle: 'none', // 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price', // 输出数据的格式 rate price vol money float
        }
    },
    // 下面是当前图形的所有需要画的线，一般非特殊的线，直接通过配置就可以得到想要的效果
    lines: [{
            className: ClDrawKBar, // 图按ClDrawKBar类来画
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['maxp'], // 参与计算最大值的标签
                minvalue: ['minp'] // 参与计算最小值的标签
            }
            // 第一根线默认的key是跟随chart的hotKey变化而变化的，其他线要么自己有数据，要么根据hotKey加上公式计算出自己的key
        },
        {
                className: ClDrawMark,
                info: {
                    drawInfo: 'none',
                    color: 'yellow',
                    drawMethod: 'strToMap',
                    fieldY: 'right',
                },
        },
        {
            className: ClDrawZLine,
            info: { // 输出在信息栏目（title）的数据
                label: ' 5:',
                fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
                format: 'price'
            },
            formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
                key: 'DAYM1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
                //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
                command: `out = this.MA('newp',5)` // 公式只能输出值到out中
            }
        },
        {
            className: ClDrawZLine,
            info: {
                label: '10:',
                fieldY: 'value',
                format: 'price'
            },
            formula: {
                key: 'DAYM2', // 获取数据的key，
                command: `out = this.MA('newp',10)` // 公式只能输出值到out中
            }
        },
        {
            className: ClDrawZLine,
            info: {
                label: '20:',
                fieldY: 'value',
                format: 'price'
            },
            formula: {
                key: 'DAYM3', // 获取数据的key，
                command: `out = this.MA('newp',20)` // 公式只能输出值到out中
            }
        },
        {
            className: ClDrawZLine,
            info: {
                label: '60:',
                fieldY: 'value',
                format: 'price'
            },
            formula: {
                key: 'DAYM4', // 获取数据的key，
                command: `out = this.MA('newp',60)` // 公式只能输出值到out中
            }
        }
    ]
}

export const CHART_KBAR_SECOND = {
    zoomInfo: ZOOM_INFO_DEF,
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: 'VOL' // 需要显示的文字信息
    },
    axisX: {
        display: 'normal',
        lines: 0,
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'none',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 1,
        left: {
            display: 'nofoot',
            middle: 'none',
            format: 'vol'
        },
        right: {
            display: 'nofoot',
            middle: 'none',
            format: 'vol'
        }
    },
    lines: [{
            className: ClDrawVBar,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['sumv'], // 参与计算最大值的标签
                minvalue: [0] // 参与计算最小值的标签
            },
            info: {
                showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
                fieldclr: 'clr', // 从颜色字段获取颜色 red green
                fieldY: 'sumv', // 需要显示的变量，从key中获取对应的数据标签
                format: 'vol'
            }
        },
        {
            className: ClDrawZLine,
            info: {
                label: '5:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'vol'
            },
            formula: {
                key: 'MVOL1', // 获取数据的key，
                command: `out = this.MA('sumv',5)` // 公式只能输出值到out中
            }
        },
        {
            className: ClDrawZLine,
            info: {
                label: '10:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'vol'
            },
            formula: {
                key: 'MVOL2', // 获取数据的key，
                command: `out = this.MA('sumv',10)` // 公式只能输出值到out中
            }
        },
        {
            className: ClDrawZLine,
            info: {
                label: '20:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'vol'
            },
            formula: {
                key: 'MVOL3', // 获取数据的key，
                command: `out = this.MA('sumv',20)` // 公式只能输出值到out中
            }
        }
    ]
}

export const CHART_ZOOM_HEAD = {
    zoomInfo: ZOOM_INFO_DEF,
    buttons: [{ // 放大
            clickName: 'zoomin',
            drawMethod: 'decr', // 画+号
        },
        { // 缩小 
            clickName: 'zoomout',
            drawMethod: 'incr', // 画-号
        },
    ],
    scroll: { // 是否显示下方的游标
        display: 'normal' // 'none' does not show normal
    },
    title: { // 标题
        display: 'text', // none does not show btn button text
        label: '主图' // label information to be displayed
    },
    axisX: {
        display: 'none',
        lines: 0, // 纵向线有几根，不包括两边的框线
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'none',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 3, // 横向线有几根
        left: { //左边的坐标信息
            display: 'both', // none不显示 both上下都显示 noupper不显示最上坐标, nofoot不显示最下坐标
            middle: 'none', // 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price', // 输出数据的格式 rate price vol money float
        },
        right: { //右边的坐标信息
            display: 'both', // none不显示 both上下都显示 noupper不显示最上坐标, nofoot不显示最下坐标
            middle: 'none', // 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price', // 输出数据的格式 rate price vol money float
        }
    },
    // 下面是当前图形的所有需要画的线，一般非特殊的线，直接通过配置就可以得到想要的效果
    lines: [
    ]
}

export const CHART_ZOOM_MIDDLE = {
    // zoomInfo: ZOOM_INFO_DEF,
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '附图' // 需要显示的文字信息
    },
    axisX: {
        display: 'none',
        lines: 0,
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'none',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 1,
        left: {
            display: 'nofoot',
            middle: 'none',
            format: 'vol'
        },
        right: {
            display: 'nofoot',
            middle: 'none',
            format: 'vol'
        }
    },
    lines: [
    ]
}

export const CHART_ZOOM_FOOT = {
    // zoomInfo: ZOOM_INFO_DEF,
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '附图' // 需要显示的文字信息
    },
    axisX: {
        display: 'normal',
        lines: 0,
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'none',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 1,
        left: {
            display: 'nofoot',
            middle: 'none',
            format: 'vol'
        },
        right: {
            display: 'nofoot',
            middle: 'none',
            format: 'vol'
        }
    },
    lines: [
    ]
}
///////////  可缩放图结束 ////////////

///////////  固定坐标图开始 ////////////
export const CHART_FIXED_FIRST = {
    style: 'normal',
    title: {
        display: 'none' // none 不显示 btn 按钮 text 文字
    },
    axisX: {
        lines: 3,
        display: 'none',
        left: {
            display: 'none', // chunk normal
        },
        right: {
            display: 'none',
        },
        middle: {
            display: 'none',
        },
    },
    axisY: {
        display: 'normal',
        lines: 3,
        left: {
            display: 'both', // none不显示，all, noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'before', // 是否有中间值 'before' = 前收盘 ‘zero’ 0为中间值
            format: 'price' // 输出数据的格式 rate, price, vol money
        },
        right: {
            display: 'both', // none不显示，noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'before', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'rate' // rate, price vol
        }
    },
    lines: [{
            className: ClDrawZLine,
            extremum: { // 如何取极值
                method: 'fixedLeft', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['maxp'], // 参与计算最大值的标签
                minvalue: ['minp'] // 参与计算最小值的标签
            },
            info: {
                fieldX: 'index',
                fieldY: 'newp',
                skipfd: 'index', // 画线时从新定位
            }
        },
        {
            className: ClDrawZLine,
            info: {
                fieldX: 'index',
                skipfd: 'index',
            },
            formula: {
                key: 'MINUAVGP', // 获取数据的key，
                command: `out = this.AVGPRC('summ', 'sumv')` // 均价,要根据股票类型做变化
            }
        }
    ]
}
export const CHART_FIXED_SECOND = {
    style: 'normal',
    title: {
        display: 'none' // none 不显示 btn 按钮 text 文字
    },
    axisX: {
        lines: 3,
        display: 'none',
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'chunk',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        display: 'normal',
        lines: 1,
        left: {
            display: 'nofoot',
            middle: 'none',
            format: 'hand'
        },
        right: {
            display: 'nofoot',
            middle: 'none',
            format: 'hand'
        }
    },
    lines: [{
        className: ClDrawVLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['curv'], // 参与计算最大值的标签
            minvalue: [0] // 参与计算最小值的标签
        },
        info: {
            fieldX: 'index',
            fieldY: 'curv',
            color: 'vol'
        }
    }]
}
///////////  固定坐标图结束 ////////////

///////////  通用图表开始 ////////////
export const CHART_NORMAL = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: 'NORMAL'
    },
    axisX: { // 纵向线有几根，不包括两边的框线
        lines: 0,
        left: {
            display: 'none', // chunk normal
        },
        right: {
            display: 'none',
        },
        middle: {
            display: 'none',
        },
    },
    axisY: {
        lines: 1, // 横向线有几根
        left: {
            display: 'both', // none不显示 both上下都显示 noupper不显示最上坐标, nofoot不显示最下坐标
            middle: 'none', // 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price' // 输出数据的格式 rate price vol money float
        },
        right: {
            display: 'both',
            middle: 'none',
            format: 'price'
        }
    },
    lines: [{
        className: ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['vol'], // 参与计算最大值的标签
            minvalue: [0] // 参与计算最小值的标签
        },
        info: {
            label: '5:', // 显示的文字信息
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            filled: true, // 是否填充
            fieldX: 'time', // X数据的字段名
            fieldY: 'value', // Y数据的字段名
            format: 'float', // Y数据显示的格式
            color: 'vol', // Y数据显示的颜色
        },
        formula: { // 从公式获取数据
            key: 'MADAY', // 获取数据的key 
            command: `out = this.MA('newp', 60)` // 移动平均计算
        }
    }]
}

///////////  通用图表结束 ////////////

///////////  竖块图表开始 ////////////
export const CHART_HORBAR = {
    title: { // 标题
        display: 'text', // none does not show btn button text
        label: '筹码分布' // label information to be displayed
    },
    scroll: { // 是否显示下方的游标
        display: 'normal' // 'none' does not show normal
    },
    buttons: [{ // 是否和主图联动
            clickName: 'locked',
            drawMethod: 'text', // 显示文本
            clickInfo: [{
                    label: '锁',
                    value: 'lock'
                },
                {
                    label: '动',
                    value: 'link'
                },
            ],
        },
    ],
    axisX: {
        display: 'none',
        lines: 0, // 纵向线有几根，不包括两边的框线
        left: {
            display: 'none', // chunk normal
        },
        right: {
            display: 'none',
        },
        middle: {
            display: 'none',
        },
        // cursor:  {
        //     format: 'money',
        // },
    },
    axisY: {
        lines: 3, // 横向线有几根
        fieldY: 'midp', // Y数据的字段名 很重要
        left: { //左边的坐标信息
            display: 'none', // none不显示, both, noupper 不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'none', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price' // 输出数据的格式 rate, price 保留一定小数位 vol 没有小数
        },
        right: { //右边的坐标信息
            display: 'none', // none不显示，noupper 不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'none', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price' // rate, price vol
        }
    },
    // 下面是当前图形的所有需要画的线，一般非特殊的线，直接通过配置就可以得到想要的效果
    lines: [{
        className: ClDrawHbar, // 图按ClDrawKBar类来画
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义 
            maxvalue: ['jgsumm'], // 参与计算最大值的标签
            minvalue: ['jgsumm'], // 参与计算最小值的标签
        },
        info: {
            label: '价量:',
            showmode: 'both', // normal 默认 fieldY
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldY: 'midp', // Y数据的字段名
            format: 'float', // Y数据显示的格式
            fieldX: 'jgsumm', // X数据的字段名
            formatX: 'money', // fieldX 输出格式
            color: 'yellow',
            maxcolor: 'red',
            mincolor: 'green',
        }
    }]
}
///////////  竖块图表结束 ////////////

export function setButtonValue(usecfg, btnName, btnValue) {
    if (usecfg.buttons !== undefined) {
        for (let index = 0; index < usecfg.buttons.length; index++) {
            if (usecfg.buttons[index].clickName === btnName) {
                usecfg.buttons[index].curValue = btnValue
            }
            
        }
    }
}